export const settings = [
  {
    label: "Content background",
    type: "background-color",
    selector: "content",
    value: "#f9fafb"
  },
  {
    label: "Form background",
    type: "background-color",
    selector: "form",
    value: "#fff"
  },
  {
    label: "Border radius",
    type: "border-radius",
    selector: "form",
    value: 6
  },
  {
    label: "Background image",
    type: "background-image",
    selector: "background",
    value: ""
  },
  {
    label: "Opacity",
    type: "opacity",
    selector: "background",
    value: "0.3"
  },

  {
    group: "header",
    type: "color",
    selector: "header",
    value: "#4d4d4d"
  },
  {
    group: "header",
    type: "font-size",
    selector: "header",
    value: 20
  },
  {
    group: "header",
    type: "font-weight",
    selector: "header",
    value: 700
  },

  {
    group: "subheader",
    type: "color",
    selector: "subheader",
    value: "#686868"
  },
  {
    group: "subheader",
    type: "font-size",
    selector: "subheader",
    value: 15
  },

  {
    group: "field",
    type: "color",
    selector: "field",
    value: "#000"
  },
  {
    group: "field",
    type: "border-color",
    selector: "field",
    value: "#e3e3e3"
  },
  {
    group: "field",
    type: "border-radius",
    selector: "field",
    value: 4
  },
  {
    group: "field",
    type: "font-weight",
    selector: "field",
    value: 400
  },
  {
    group: "button",
    type: "color",
    selector: "button",
    value: "#fff"
  },
  {
    group: "button",
    type: "background-color",
    selector: "button",
    value: "#1677be"
  },
  {
    group: "button",
    type: "border-radius",
    selector: "button",
    value: 24
  },
  {
    group: "button",
    type: "font-weight",
    selector: "button",
    value: 700
  },
  {
    group: "guarantee",
    type: "color",
    selector: "guarantee",
    value: "#4d4d4d"
  },
  {
    group: "guarantee",
    type: "font-size",
    selector: "guarantee",
    value: 13
  },
  {
    group: "guarantee",
    type: "font-weight",
    selector: "guarantee",
    value: 400
  }
]
